module.exports = __webpack_public_path__ + "images/af2e57537d37ceb69b592a17988ed2dd-footerLogo.png";